import React, { lazy, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import useTheme from '@material-ui/core/styles/useTheme';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import ParentStyled from './style';
import { loadStyle, getNewObject, loadPageConfig } from 'globalutils/fmUtils';
let Styled = loadStyle(ParentStyled, 'pages/web/AdvancedConfig');
const config = loadPageConfig();
const Title = lazy(() => import(`globalcomponents/Title`));
const Content = lazy(() => import(`@/${config.advancedDvirEnabled[1].name}`));

const AdvancedConfig = (parentProps) => {
  const { fetchAdvancedConfig } = parentProps;

  const apiId = 'fetchAdvancedConfig';

  const history = useHistory();
  const theme = useTheme();
  const i18n = useTranslation();
  const commonParentProps = { history, i18n, Styled, theme };

  useEffect(() => {
    fetchAdvancedConfig({
      apiId
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <RenderComponent
        {...config.advancedDvirEnabled[0]}
        parentProps={parentProps}
        commonParentProps={commonParentProps}
        component={Title}
      />
      <RenderComponent
        {...config.advancedDvirEnabled[1]}
        parentProps={parentProps}
        commonParentProps={commonParentProps}
        component={Content}
      />
    </>
  );
};

const RenderComponent = ({
  name,
  props,
  commonProps,
  title,
  parentProps,
  commonParentProps,
  component,
  ...rest
}) => {
  const Component = component;
  let newProps = props?.length ? getNewObject(parentProps, props) : {};
  newProps = {
    ...newProps,
    ...(commonProps?.length ? getNewObject(commonParentProps, commonProps) : {})
  };
  return <Component {...rest} {...newProps} />;
};
const mapState = (state) => {
  return {
    apiStatus: state.asyncRequests,
    advancedConfig: state.advancedConfig,
    filters: state.filters
  };
};
const mapDispatch = (dispatch) => {
  return {
    fetchAdvancedConfig: (data) => dispatch.advancedConfig.fetchData(data),
    updateAdvancedConfig: (data) =>
      dispatch.advancedConfig.updateAdvancedConfig(data),
    saveData: (data) => dispatch.advancedConfig.saveData(data),
    getFilters: (data) => dispatch.filters.fetchData(data),
    updateAdvancedConfigData: (data) =>
      dispatch.advancedConfig.updateAdvancedConfigData(data)
  };
};

export default connect(mapState, mapDispatch)(AdvancedConfig);
AdvancedConfig.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  fetchAdvancedConfig: PropTypes.func.isRequired
};
